module.exports = __webpack_public_path__ + "static/img/15.28173ec.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/12/sp/15.png
// module id = 9TH2
// module chunks = 0